export default "__VITE_ASSET__Bz1Fv8$7__"